<template>
  <div class="thirty-details">
    <div class="header">
      <div>交易类型</div>
      <div>交易金额（元）</div>
      <div>交易笔数（笔）</div>
    </div>
    <div class="body">
      <div
        v-for="(item, index) in activeWithThirtyDay"
        :key="index"
        class="item"
      >
        <div>{{ item.name || '' }}</div>
        <div>{{ item.tradeAmt || 0 }}</div>
        <div>{{ item.tradeCount || 0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchBusinessDetails } from '@/api/merchant/merchant'
export default {
  data() {
    return {
      businessId: this.$route.query.businessId,
      activeWithThirtyDay: {}
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      fetchBusinessDetails({
        businessId: this.businessId
      }).then(res => {
        this.activeWithThirtyDay = res.activeWithThirtyDay || {}
        console.log(res)
      })
    }
  }
}
</script>
